import { useDispatch, useReduxState } from 'hooks';
import api from 'api';
import { actions } from 'store';
import { getAchievementAdminPermissionOptions } from 'lib/achievements';
import { OwnersAndAdminsManager } from 'components/common/ownersAndAdmins';
import { AchievementDelete } from '.';

const AchievementManage = () => {
  const { dispatch } = useDispatch();

  const {
    messages,
    pageState: { achievement }
  } = useReduxState();

  const updateAchievement = async () => {
    try {
      const achievements = await api.get(
        `/admin/achievements?id=${achievement.id}`
      );

      dispatch(
        actions.updatePageState({
          achievement: achievements.data.achievements[0]
        })
      );
    } catch (err) {
      await dispatch.handleErrorDispatch(err);
    }
  };

  const adminPermissions = getAchievementAdminPermissionOptions({ messages });
  const permissionsTooltips = {
    owner: messages.achievementAdminsTooltipOwner,
    'manage-users': messages.achievementAdminsTooltipManageUsers,
    'view-only': messages.achievementAdminsTooltipViewOnly
  };

  return (
    <div className="manage">
      <div>
        <OwnersAndAdminsManager
          fallbackUrl="/achievements"
          permissions={adminPermissions}
          permissionsTooltips={permissionsTooltips}
          updateProduct={updateAchievement}
          url={`/admin/achievements/${achievement.id}/admins`}
        />
      </div>

      <div style={{ marginTop: 40 }}>
        <AchievementDelete />
      </div>
    </div>
  );
};

export default AchievementManage;
